import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "SKU Data Table", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Total Levels", -1)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Location Quantity", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Pallet Width", -1)
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Pallet Depth", -1)
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Pallet Height", -1)
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Pallet Volume", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Pallet Fill Rate", -1)
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Minimum Pallets Stored per SKU", -1)
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Minimum Days Picking Inventory", -1)
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Simulation Days", -1)
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "System Fill Rate", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
    type: "submit"
  }, " Submit ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("select", {
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.TableID) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skuTables, (table) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: table.tableID,
                    value: table.tableID
                  }, _toDisplayString(table.name), 9, _hoisted_7))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.TableID]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.TotalLevels) = $event)),
                min: "1",
                step: "1"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.TotalLevels,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.LocationQuantity) = $event)),
                min: "50",
                step: "50"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.LocationQuantity,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.PalletWidth) = $event)),
                step: "0.01"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.PalletWidth,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.PalletDepth) = $event)),
                step: "0.01"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.PalletDepth,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.PalletHeight) = $event)),
                step: "0.01"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.PalletHeight,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                value: _ctx.palletVolume,
                readonly: ""
              }, null, 8, _hoisted_26)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.PalletFillRate) = $event)),
                min: "0",
                max: "1",
                step: "0.01"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.PalletFillRate,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.MinimumPallets) = $event)),
                min: "1",
                step: "1"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.MinimumPallets,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.MinimumDays) = $event)),
                min: "0",
                step: "0.1"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.MinimumDays,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.SimulationDays) = $event)),
                min: "1",
                step: "1"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.SimulationDays,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.FillRate) = $event)),
                min: "0",
                max: "1",
                step: "0.01"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.FillRate,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _hoisted_42
        ])
      ], 32)
    ])
  ]))
}